import { Container } from '@getgo/container-client'
import { isContainer } from '../container/helpers'
import type { AuthBase } from './authentication.base'
import { AuthContainer } from './authentication.container'
import { AuthWeb } from './authentication.web'

let instance: AuthBase | undefined = undefined

// @deprecated only for test
export const resetInstance = () => (instance = undefined)

export const getInstance = async () => {
  if (!instance) {
    instance = await makeAuthentication()
  }

  return instance
}

/**
 * @description factory to split web instance VS container instance
 */
const makeAuthentication = async (): Promise<AuthBase> => {
  if (isContainer() && Container.isPluginAvailable('BrowserAuth')) {
    return new AuthContainer()
  }

  return new AuthWeb()
}
